module.exports = __webpack_public_path__ + "img/38.dcb66ed2.png";